export default {
  title: 'Oferta sobreposta no mesmo período',
  buttons: {
    save_as_active: 'Definir como nova oferta ativa',
    save_as_inactive: 'Guardar como Inativa',
    cancel: 'Cancelar',
  },
  description: {
    base: '{{offer}} sobrepõe-se à oferta ativa {{overlappingOffer}} em {{weekday}}{{between}}. Só pode ter uma oferta ativa no mesmo período.',
    between: ', entre {{start}}-{{end}}',
  },
  how_to_resolve: {
    title: 'Como resolver: Escolha uma opção abaixo.',
  },
};
